// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/glassy-water-landing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/glassy-water-landing/glassy-water-landing.js';

mount([g0]);
